var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../../Decorators/objectTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import ModelTraits from "../../ModelTraits";
import TableChartStyleTraits from "./ChartStyleTraits";
import TableColorStyleTraits from "./ColorStyleTraits";
import TableLabelStyleTraits from "./LabelStyleTraits";
import TableOutlineStyleTraits from "./OutlineStyleTraits";
import TablePointSizeStyleTraits from "./PointSizeStyleTraits";
import TablePointStyleTraits from "./PointStyleTraits";
import TableTrailStyleTraits from "./TrailStyleTraits";
import TableTimeStyleTraits from "./TimeStyleTraits";
let TableStyleTraits = (_dec = primitiveTrait({
  name: "ID",
  description: "The ID of the style.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Title",
  description: "The human-readable title of the style. Set this to null to remove the style entirely.",
  type: "string",
  isNullable: true
}), _dec3 = primitiveTrait({
  name: "Region Column",
  description: "The column to use for region mapping.",
  type: "string",
  isNullable: true
}), _dec4 = primitiveTrait({
  name: "Latitude Column",
  description: "The column to use for the latitude of points. If `Region Column` is specified, this property is ignored.",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "Longitude Column",
  description: "The column to use for the longitude of points. If `Region Column` is specified, this property is ignored.",
  type: "string"
}), _dec6 = objectTrait({
  name: "Color",
  description: "Options for controlling the color of points or regions.",
  type: TableColorStyleTraits
}), _dec7 = objectTrait({
  name: "Color",
  description: "Options for controlling the symbolization. This excludes color (see TableColorStyleTraits) and pointSize (see TablePointSizeStyleTraits).",
  type: TablePointStyleTraits
}), _dec8 = objectTrait({
  name: "Color",
  description: "Options for controlling the symbolization. This excludes color (see TableColorStyleTraits) and pointSize (see TablePointSizeStyleTraits).",
  type: TableOutlineStyleTraits
}), _dec9 = objectTrait({
  name: "Point trail",
  description: "Options for controlling the trail or path behind a time-series point.",
  type: TableTrailStyleTraits
}), _dec0 = objectTrait({
  name: "Label",
  description: "Options for controlling the labels.",
  type: TableLabelStyleTraits
}), _dec1 = objectTrait({
  name: "Point Size",
  description: "Options for controlling the size of points. This property is ignored for regions. This will override TablePointStyleTraits marker width/height if `pointSize.column` can be resolved to scalar column",
  type: TablePointSizeStyleTraits
}), _dec10 = objectTrait({
  name: "Chart",
  description: "Options for controlling the chart created from this CSV.",
  type: TableChartStyleTraits
}), _dec11 = objectTrait({
  name: "Time",
  description: "Options for controlling how the visualization changes with time.",
  type: TableTimeStyleTraits
}), _dec12 = primitiveTrait({
  name: "Hide style",
  description: "Hide style from \"Display Variable\" drop-down in workbench. It is hidden by default if number of colors (enumColors or numberOfBins) is less than 2 - as a ColorMap with a single color isn't super useful",
  type: "boolean"
}), _class = class TableStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "id", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "regionColumn", _descriptor3, this);
    _initializerDefineProperty(this, "latitudeColumn", _descriptor4, this);
    _initializerDefineProperty(this, "longitudeColumn", _descriptor5, this);
    _initializerDefineProperty(this, "color", _descriptor6, this);
    _initializerDefineProperty(this, "point", _descriptor7, this);
    _initializerDefineProperty(this, "outline", _descriptor8, this);
    _initializerDefineProperty(this, "trail", _descriptor9, this);
    _initializerDefineProperty(this, "label", _descriptor0, this);
    _initializerDefineProperty(this, "pointSize", _descriptor1, this);
    _initializerDefineProperty(this, "chart", _descriptor10, this);
    _initializerDefineProperty(this, "time", _descriptor11, this);
    _initializerDefineProperty(this, "hidden", _descriptor12, this);
  }
  static isRemoval(style) {
    return style.title === null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "regionColumn", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "latitudeColumn", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "longitudeColumn", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "point", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TablePointStyleTraits();
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "outline", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TableOutlineStyleTraits();
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "trail", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TableTrailStyleTraits();
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "label", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TableLabelStyleTraits();
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "pointSize", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "chart", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "time", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "hidden", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TableStyleTraits as default };